<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import {useCalculatorStore} from "@js/store/CalculatorStore.js";
import BathroomCalculator from "@js/components/Sections/Calculator/BathroomCalculator.vue";
import CalculatorNav from "@js/components/Sections/Calculator/CalculatorNav.vue";
import SVPCalculator from "@js/components/Sections/Calculator/SVPCalculator.vue";
import GroutCalculator from "@js/components/Sections/Calculator/GroutCalculator.vue";

export default defineComponent({
    name: "CalculatorPage",
    components: {GroutCalculator, SVPCalculator, CalculatorNav, BathroomCalculator, Breadcrumbs, MobileTopBar},
    beforeMount() {
        this.calculatorStore.resetData()
        this.calculatorStore.syncUrlParamsWithState()
    },
    setup() {
        const calculatorStore = useCalculatorStore()

        return {calculatorStore}
    }
})
</script>

<template>
    <MobileTopBar/>
    <div class="container mb-5">
        <Breadcrumbs/>
        <h1 class="text-2xl md:text-3xl font-bold mb-5">
            {{ calculatorStore.calc_title }}
        </h1>
    </div>
    <div class="max-sm:ms-5 sm:container mb-5">
        <CalculatorNav/>
    </div>
    <div class="container mb-5">
        <BathroomCalculator v-show="calculatorStore.calc_type === 'bath'"/>
        <SVPCalculator v-show="calculatorStore.calc_type === 'svp'"/>
        <GroutCalculator v-show="calculatorStore.calc_type === 'grout'"/>
    </div>
</template>

<style scoped lang="scss">

</style>
